(function () {
  function initBYS(root = document) {
    const el = root.querySelector('[data-bys]');
    if (!el) return;

    // evita doppie inizializzazioni (Theme Editor può ricaricare sezioni)
    if (el.dataset.bysInit === '1') return;
    el.dataset.bysInit = '1';

    // Esempio: log per verificare che funzioni
    console.log('Build Your Solution™ initialized');

    // TODO: qui metteremo la logica vera
  }

  document.addEventListener('DOMContentLoaded', () => initBYS());

  // quando Shopify ricarica una sezione nel Theme Editor
  document.addEventListener('shopify:section:load', (e) => initBYS(e.target));
})();
